import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import * as api from 'config/api';
import * as env from 'config/environment';

import { formatDateForString } from 'utils/formatter';
import SymbolNews from 'components/features/news/SymbolNews';
import Icon from 'components/commons/icon/Icon';
import Loading from 'components/commons/loading/Loading';

const News: React.FC = () => {
  const { symbol, id } = useParams();

  const [news, setNews] = useState<api.GetNewsResult | null>();
  const unmounted = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      // unmount
      unmounted.current = true;
    };
  }, []);

  useEffect(() => {
    if (!id) return;

    api.getNews(id).then(ret => {
      if (!unmounted.current) {
        setNews(ret);
      }
    });
  }, [id, setNews, symbol]);

  if (!symbol || !id || !news)
    return (
      <Loading
        loading={true}
        style={{
          paddingTop: '100px',
          paddingBottom: '100px',
        }}
      />
    );

  return (
    <div className="mx-2 mt-4">
      <div className="ui-card">
        <div className="mx-4 my-6">
          <div className="text-base font-bold">{news.Title}</div>
          <div className="mt-2 text-sm text-gray-500">
            {formatDateForString(news.Date, 'yyyy/M/d HH:mm')}
          </div>
          {news.Creator ? (
            <div className="mt-2 text-sm text-gray-500">
              著者: {news.Creator}
            </div>
          ) : (
            <div></div>
          )}
          <div className="mt-4">
            {news.Image ? (
              <img
                className="ml-2 mt-2 float-right w- w-32"
                alt={news.Title}
                src={news.Image}
              />
            ) : (
              <div></div>
            )}
            <div className="whitespace-pre-wrap text-sm">{news.Body}</div>
            {news.PDFList ? (
              <div className="mt-2">
                {news.PDFList.map(pdf => {
                  const url = `https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURI(
                    pdf
                  )}`;
                  return (
                    <div
                      key={pdf}
                      className="mt-2 overflow-y-auto w-full"
                      style={{ height: '500px' }}>
                      <iframe
                        key={pdf}
                        title="pdf"
                        src={url}
                        className="w-full h-full"></iframe>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <div className="mt-4 text-sm text-gray-500">
            配信元: {news.Provider}
          </div>
        </div>
      </div>
      <div className="ui-card">
        <div className="flex p-4 border-b border-gray-300">
          <div className="text-base font-bold">この銘柄のニュース</div>
        </div>
        <SymbolNews symbol={symbol} />
        <div className="my-2 flex items-center justify-center text-base text-link">
          <a
            href={`${env.minkabuStockInfoBaseURL}/${symbol}/news`}
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2 border border-solid border-link rounded">
            <span>みんかぶ　株式ニュースへ</span>
            <Icon name="external-link" className="ml-1"></Icon>
          </a>
        </div>
      </div>
    </div>
  );
};

export default News;
